import { Component } from '@angular/core';

@Component({
  selector: 'loader',
  templateUrl: 'loader.html'
})
export class Loader {

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/theme/loader/loader.ts